export const defaultMaterial : Material = {
    specular: [1.0, 1.0, 1.0],
    diffuse: [1.0, 1.0, 0.0],
    ambient: [0.2, 0.2, 0.2],
    smoothness: 10.0
}